<div class="cursor-pointer w-full" (click)="selectMethod($event)">
    <div class="w-full">
        <img class="other-payment-options" src="assets/icons/Icons/other-payment-options/masterpass_logo.png" alt="masterpass">
    </div>
    <div class="grid grid-cols-5 gap-1">
        <p class="col-span-4 subtext mt-2">Scan to pay by Masterpass</p>
        <div class="col-span-1">
            <mat-icon class="cursor-pointer float-right" (click)="toggleListView()">info</mat-icon>
        </div>
    </div>
</div>
